// useRewardStore用来管理用户的心和钻石的获取和消耗
// 应该包含当前用户的经验、心、钻石等
// 向supabase同步，更新等
// 增加、删除经验、心、钻石
// 和user_id挂钩
// @constant/reward.ts下的逻辑应该转移到这里

import { create } from "zustand";

interface RewardStore {
  buyHeartPopup: boolean;
  diamondPopup: boolean;
  demoRewardMode: boolean;
  setDemoRewardMode: (enabled: boolean) => void;
}

const useRewardStore = create<RewardStore>((set) => ({
  buyHeartPopup: false,
  diamondPopup: false,
  demoRewardMode: false,
  setDemoRewardMode: (enabled) => set({ demoRewardMode: enabled }),
}));

export default useRewardStore;
